import { useCallback, useEffect, useState } from "react";
import { getStablesFees } from "../Services/stablesApi";

export const useStablesFees = () => {
  const [fees, setFees] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await getStablesFees();
      setFees(result);
    } catch (err) {
      setFees(null);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { fees, loading, error, reload: load };
};
